import request from "@/utils/request";

export default function getMemberAllMonthly(memberId, memberType) {

    return request({
        url: `/device/memberMonthly/getMemberAllMonthly/${memberId}/${memberType}`,
    })
}
